var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import * as classNames from 'classnames';
import * as s from './Checkbox.sss';
export const Checkbox = (_a) => {
    var { checked, onCheck, children, className } = _a, props = __rest(_a, ["checked", "onCheck", "children", "className"]);
    return (React.createElement("label", { className: classNames(s.root, className) },
        React.createElement("div", { className: classNames(s.checkboxOuter, { [s.checked]: checked }) },
            React.createElement("input", Object.assign({ type: "checkbox", className: s.checkbox, checked: checked, onChange: onCheck }, props))),
        children));
};
